export default __webpack_public_path__ + "static/media/feature_1.6fec1494.jpg";